<h2 mat-dialog-title>Negative Payment Confirmation</h2>
<mat-dialog-content class="mat-typography">
  <h4>Payment amount is a negative amount. Press OK if you wish to continue.</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>
